import React from 'react';

import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import './ConfirmationModal.scss';

const ConfirmationModal = ({
    show,
    title,
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    icon = null,
    iconAlt = 'Icon',
    centered = true,
    onConfirm,
    onCancel,
}) => {
    const hasIcon = Boolean(icon);

    return (
        <Modal
            centered={centered}
            show={show}
            className={hasIcon ? 'confirmation-modal modal-with-icon' : 'confirmation-modal'}
            onHide={onCancel}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {hasIcon && (
                        <img
                            src={icon}
                            alt={iconAlt}
                            className="modal-icon"
                            width={32}
                            height={32}
                        />
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {title && (
                    <h1 className="modal-title">{title}</h1>
                )}
                {typeof message === 'string' ? (
                    <p className="mb-0">{message}</p>
                ) : (
                    message
                )}
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <Button
                    variant="primary"
                    onClick={onConfirm}
                >
                    {confirmText}
                </Button>
                <Button
                    variant="outline-primary"
                    onClick={onCancel}
                >
                    {cancelText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ConfirmationModal.propTypes = {
    show: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    icon: PropTypes.string,
    iconAlt: PropTypes.string,
    centered: PropTypes.bool,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default React.memo(ConfirmationModal);

